import axios from './customAxios'
export default {
  saveEtiqueta: async function (etiqueta) {
    var response = null
    response = await axios.post(`${process.env.VUE_APP_BACKEND_URL}/api/Labeling_LabelDesigner/`, etiqueta)
    return response
  },
  getEtiqueta: async function (id) {
    var response = null
    response = await axios.post(`${process.env.VUE_APP_BACKEND_URL}/api/Labeling_LabelDesigner/GetEtiqueta/` + id)
    return response
  },
  getEtiquetaVersion: async function (id, version) {
    var response = null
    response = await axios.post(`${process.env.VUE_APP_BACKEND_URL}/api/Labeling_LabelDesigner/GetEtiqueta/` + id + '/' + version)
    return response
  },
  getEtiquetaJson: async function (id) {
    var response = null
    response = await axios.post(`${process.env.VUE_APP_BACKEND_URL}/api/Labeling_LabelDesigner/GetEtiquetaJson/` + id)
    return response
  },
  getEtiquetaVersionJson: async function (id, version) {
    var response = null
    response = await axios.post(`${process.env.VUE_APP_BACKEND_URL}/api/Labeling_LabelDesigner/GetEtiquetaJson/` + id + '/' + version)
    return response
  },
  getImportedImages: async function () {
    var response = null
    response = await axios.get(`${process.env.VUE_APP_BACKEND_URL}/api/Labeling_LabelDesigner/ImportedImages/`)
    return response
  },
  getPredefinedImages: async function () {
    var response = null
    response = await axios.get(`${process.env.VUE_APP_BACKEND_URL}/api/Labeling_LabelDesigner/PredefinedImages/`)
    return response
  },
  saveImage: async function (name, imageData) {
    var response = null
    var image = imageData.split(',')
    var imageDTO = {
      Image: image[1],
      Extension: image[0].split('/')[1].split(';')[0]
    }
    response = await axios.post(`${process.env.VUE_APP_BACKEND_URL}/api/Labeling_LabelDesigner/AddImage/` + name, imageDTO)
    return response
  },
  getZpl: async function (etiqueta) {
    var response = null
    response = await axios.post(`${process.env.VUE_APP_BACKEND_URL}/api/Labeling_LabelDesigner/GetZPL/`, etiqueta)
    return response
  },
  getPdf: async function (etiqueta) {
    var response = null
    response = await axios.post(`${process.env.VUE_APP_BACKEND_URL}/api/Labeling_LabelDesigner/GetPDF/`, etiqueta)
    return response
  },
  saveNewLabelVersion: async function (id, etiqueta) {
    var response = null
    response = await axios.put(`${process.env.VUE_APP_BACKEND_URL}/api/Labeling_LabelDesigner/` + id, etiqueta)
    return response
  },
  getPurposes: async function () {
    var response = null
    response = await axios.get(`${process.env.VUE_APP_BACKEND_URL}/api/Labeling_Purposes/GetTypes`)
    return response
  }
}
